var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import ko from 'dayjs/locale/ko';
import React from 'react';
import RightAngleArrowIcon from '@/assets/icon/ic_angle_bracket_right.svg';
import { color } from '@/constant/color';
import useAppComponents from '@/hooks/useAppComponents';
import useNavigation from '@/navigation/useNavigation';
import { SccPressable } from '@/components/SccPressable';
import { Image, Text, View } from 'react-native';
dayjs.locale(ko);
export default function WeeklyConquererSection() {
    var _a;
    const navigation = useNavigation();
    const today = dayjs();
    const { api } = useAppComponents();
    const { data } = useQuery({
        queryKey: ['ConquererActivity'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.getAccessibilityActivityReportPost()).data; }),
    });
    // 오늘이 일요일이면 6일 전 월요일
    // 오늘이 일요일이 아니면 이번주 월요일
    const startMonday = today.day() === 0
        ? today.subtract(6, 'day')
        : today.startOf('week').add(1, 'day');
    return (_jsx(View, { className: "py-8 px-5 gap-6 bg-white", children: _jsxs(View, { children: [((_a = data === null || data === void 0 ? void 0 : data.thisWeekConqueredWeekdays) === null || _a === void 0 ? void 0 : _a.length) === 0 && (_jsx(Image, { className: "w-[170px] h-[30px] mb-1", resizeMode: "contain", source: require('@/assets/img/conquer_today_tooltip.png') })), _jsxs(View, { className: "flex-row items-center justify-between mb-4", children: [_jsx(Text, { className: "text-black text-[18px] leading-[29px] font-pretendard-bold", children: "\uD558\uB8E8 \uD55C \uCE78" }), _jsxs(SccPressable, { className: "flex-row items-center h-6", elementName: "weekly_conquerer_more_button", onPress: () => 
                            // Search는 Main tab 내부에 있어 nested navigate 필요.
                            // initSortOption은 지정하지 않음 → 다른 검색 진입과 동일하게
                            // filterAtom default(LOW_SCORE = 접근레벨낮은순) 적용.
                            navigation.navigate('Main', {
                                screen: 'Search',
                                params: {
                                    initKeyword: '',
                                },
                            }), children: [_jsx(Text, { className: "text-[14px] leading-[22px] text-brand-50 font-pretendard-medium", children: "\uC815\uBCF5\uD558\uB7EC \uAC00\uAE30" }), _jsx(RightAngleArrowIcon, { color: color.brandColor, width: 20 })] })] }), _jsx(View, { className: "flex-row justify-between gap-1", children: Array.from({ length: 7 }).map((_, i) => (_jsx(View, { className: "flex-1 aspect-square justify-center items-center rounded-[16px] bg-gray-10", children: _jsx(DailyStamp, { day: startMonday.add(i, 'day') }, i) }, i))) })] }) }));
}
function DailyStamp({ day }) {
    var _a;
    const { api } = useAppComponents();
    const { data } = useQuery({
        queryKey: ['ConquererActivity'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () { return (yield api.getAccessibilityActivityReportPost()).data; }),
    });
    const days = (_a = data === null || data === void 0 ? void 0 : data.thisWeekConqueredWeekdays) !== null && _a !== void 0 ? _a : [];
    const success = days.includes(day.locale('en').format('dddd').toUpperCase());
    if (!success) {
        return (_jsx(Text, { className: "text-[16px] leading-[18px] text-gray-70 text-center", children: day.format('ddd') }));
    }
    // 매주 스탬프 위치가 바뀌게 / 하지만 한 주 동안은 고정적으로 찍히도록
    const stamps = [
        require('@/assets/img/stamp_wheely.png'),
        require('@/assets/img/stamp_flag.png'),
        require('@/assets/img/stamp_star.png'),
        require('@/assets/img/stamp_buggy.png'),
    ];
    const stampIndex = day.diff(dayjs('2020-01-01'), 'day') % stamps.length;
    return _jsx(Image, { className: "w-10 h-10", source: stamps[stampIndex] });
}
